<script lang="ts">
  import Radio from '../radio/Radio.svelte';

  export let label = '';
  export let value: string;
  export let options: Array<{value: string; label: string}>;
  export let id = '';
  export let required = false;
  export let disabled = false;
  export let onChange: svelte.JSX.FormEventHandler<HTMLInputElement> = () => {};
</script>

<style lang="postcss">
  .container {
    display: grid;
    gap: 0.25rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .container {
      grid-template-columns: 1fr 2fr 1fr;
      align-items: center;
      gap: 1.5rem;
    }

    .container > div:first-child {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }

  .radios {
    display: flex;
    gap: 1.5rem;
  }
</style>

<div class="container">
  <div>
    {#if label}
      <label for={id}>{label}{required ? '*' : ''}</label>
    {/if}
  </div>
  <div class="radios">
    {#each options as option}
      <Radio
        {id}
        name={id}
        value={option.value}
        bind:group={value}
        {required}
        {disabled}
        {onChange}>
        {option.label}
      </Radio>
    {/each}
  </div>
</div>
